<template>
  <div>
    <el-button
      style="padding: 10px"
      disabled
      @click="ComPortTesting"
    >
      COM測試
    </el-button>
    <el-input
      style="padding: 10px"
      type="textarea"
      :rows="10"
      placeholder=""
      v-model="log">
    </el-input>
  </div>
</template>

<script>
export default {
  data() {
    return {
      log: '',
    };
  },
  methods: {
    async ComPortTesting(){
      //this.Log('testing!');
      this.Log(`${process.env.VUE_APP_COM_URL}`);
      const res = await this.$axios({
        method: 'get',
        apiName: 'api/comtest',
        useUrl:`${process.env.VUE_APP_COM_URL}`,
      });
      this.Log(res.data);
    },
    Log(log){
      this.log += `${log}\n`;
      console.log(log);
    },
  },
};
</script>

<style>

</style>